import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getUserWallet = () => {
  return http.get(
    `${getBaseUrl()}/person_wallet`
  );
};

export const getUserWalletProductLog = () => {
  return http.get(
    `${getBaseUrl()}/person_wallet_product_log`
  );
};

export const getPersonWalletChange = () => {
  return http.get(
    `${getBaseUrl()}/person_wallet_change`, {
      responseType: 'blob',
    }
  );
};

export const getPersonWithdrawal = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/person_withdrawal`
    );
  }
  return http.get(
    `${getBaseUrl()}/person_withdrawal?${paginate}`
  );
};

export const getNewWithdrawal = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/new_withdrawal`
    );
  }
  return http.get(
    `${getBaseUrl()}/new_withdrawal?${paginate}`
  );
};

export const submitWalletWithdrawal = (data) => {
  return http.post(
    `${getBaseUrl()}/withdrawal`,
    data
  );
};

export const updateWalletWithdrawal = (data) => {
  http.hasFile();
  return http.put(
    `${getBaseUrl()}/withdrawal/${data.id}`,
    data
  );
};

// export const updatePersonProfile = data => {
//   
//   return http.put(
//     `${getBaseUrl()(}/person_profile`,
//     data
//   );
// };
